import { TrackJsConfigService } from '@com-delta-idp/mnx-utils';
import { trackJsConfig } from '../models';

export const provideTrackJsConfigService = (): (() => TrackJsConfigService) => {
  return () => {
    return new TrackJsConfigService(trackJsConfig);
  };
};
